import { Space, Text } from '@pyt/micros'
import Image from 'next/image'
import { useEffect, useMemo, useState } from 'react'

import Rating from '../../Rating'

const _SM_Ratings = [
	{
		logo: 'images/web_app/social-media-logos/facebook-5.svg',
		rating: 5.0,
		reviews: '828',
		type: 'FB',
		width: 104,
		height: 20,
	},
	{
		logo: 'images/web_app/social-media-logos/google-2015.svg',
		rating: 4.7,
		reviews: '1,017',
		type: 'GOOGLE',
		width: 86,
		height: 24,
	},
	{
		logo: 'images/web_app/social-media-logos/trustpilot-vector.svg',
		rating: 4.8,
		reviews: '110',
		type: 'TP',
		width: 93,
		height: 20,
	},
]

const SocialMediaRatings = ({ color = '#ffffffa8', logoColor = false }) => {
	const [active, setActive] = useState(0)

	useEffect(() => {
		const timerId = setTimeout(() => {
			let tmpActive = active + 1
			if (tmpActive === _SM_Ratings.length) tmpActive = 0

			setActive(tmpActive)
		}, 7000)

		return () => clearTimeout(timerId)
	}, [active])

	const currentData = useMemo(() => _SM_Ratings[active], [active])

	const getRatingsImage = currentData => {
		switch (currentData.type) {
			case 'TP':
				return (
					<Image
						src="images/web_app/social-media-logos/trustpilot-review-stars.svg"
						alt="trustpilot-review-stars"
						width={118}
						height={22}
						layout="fixed"
					/>
				)
			case 'GOOGLE':
				return (
					<Rating
						rootClassName="rating-yellow"
						starClassName="pyt-star-16"
						rating={currentData.rating.toFixed(1)}
					/>
				)
			case 'FB':
				return (
					<Rating
						rootClassName="rating-yellow"
						starClassName="pyt-star-16"
						rating={currentData.rating.toFixed(1)}
					/>
				)
			default:
				return null
		}
	}
	// https://pyt-images.imgix.net/images/web_app/social-media-logos/facebook-5.svg?auto=format&fit=max&w=256
	return (
		<Space direction="column" gutter={8} alignItems="flex-start">
			<Image
				src={currentData.logo}
				alt={currentData.type}
				width={currentData.width}
				height={currentData.height}
				className={logoColor ? 'logo-img' : null}
			/>
			<Space.Item>{getRatingsImage(currentData)}</Space.Item>
			<Space.Item>
				<Text color={color} fontWeight={600} fontSize={15} lineHeight={20}>
					{currentData.rating}/5 from {currentData.reviews} reviews
				</Text>
			</Space.Item>
		</Space>
	)
}

export default SocialMediaRatings
